module.exports = __webpack_public_path__ + "img/Frame 5125.ede81f78.jpg";